import { getSubdomain, fetchWithAuth } from "../helpers";
import { API_PASSWORD } from "../config";

export const getDailySessions = async (fromDate, toDate) => {
  const subdomain = getSubdomain();
  const rootId = localStorage.getItem("branch_id");
  let url = `https://${subdomain}.restocash.app/api/get/root/daliy/sessions/${rootId}`;

  // Add date parameters to query string
  const params = new URLSearchParams();
  if (fromDate) params.append("from", fromDate);
  if (toDate) params.append("to", toDate);

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  try {
    const response = await fetchWithAuth(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(`Error fetching daily sessions: ${response.statusText}`);
    }

    const data = await response.json();
    return data.data || [];
  } catch (error) {
    console.error("Failed to fetch daily sessions:", error);
    throw error;
  }
};

export const getDailySessionTransactions = async (sessionId) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/get/daliy/session/transactions/${sessionId}`;

  try {
    const response = await fetchWithAuth(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching transactions for session ${sessionId}: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data.data || [];
  } catch (error) {
    console.error("Failed to fetch transactions for session:", error);
    throw error;
  }
};

// جلب كل المعاملات البنكية (الخزن)
export const getAllBankTransactions = async (params = {}) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;
  let url = `https://${subdomain}.restocash.app/api/transactions?api_password=${apiPassword}`;

  // Build query string from params
  const query = Object.entries(params)
    .filter(([_, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");

  if (query) url += `&${query}`;

  try {
    const response = await fetchWithAuth(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching bank transactions: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data.data || {};
  } catch (error) {
    console.error("Failed to fetch bank transactions:", error);
    throw error;
  }
};

// جلب إحصائيات المنتجات المباعة في اليومية
export const getDailySessionsStatistics = async (fromDate, toDate) => {
  const subdomain = getSubdomain();

  // ملاحظة: fetchWithAuth هيضيف api_password لوحده في الـ URL لما isFormData=true
  const url = `https://${subdomain}.restocash.app/api/orders/statistics`;

  try {
    const formData = new FormData();
    formData.append("from_date", fromDate);
    formData.append("to_date", toDate);

    const response = await fetchWithAuth(
      url,
      {
        method: "POST",
        body: formData,
      },
      true,  // ✅ isFormData = true (ده المهم)
      true   // requireToken (خليه true لو endpoint محتاج توكن)
    );

    if (!response.ok) {
      throw new Error(`Error fetching daily sessions statistics: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Failed to fetch daily sessions statistics:", error);
    throw error;
  }
};

// جلب القوائم (المنيو)

export const getUserShiftReport = async (userId, shiftId) => {
  const subdomain = getSubdomain();
  const apiPassword = "Project102$_";
  const token = localStorage.getItem("token");
  const url = `https://${subdomain}.restocash.app/api/get/user/shift/report/${userId}/${shiftId}?api_password=${apiPassword}`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(
      data.message || "❌ فشل في جلب تقرير معاملات المستخدم في الشيفت."
    );
  }

  return data.data || {};
};

export const generateGeneralReports = async (params = {}) => {
  const subdomain = getSubdomain();
  const url = `https://${subdomain}.restocash.app/api/genral/reportes`;

  const formData = new FormData();

  // 👈 استخدم القيم القادمة من الواجهة
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      formData.append(key, value);
    }
  });

  const response = await fetchWithAuth(
    url,
    {
      method: "POST",
      body: formData,
    },
    true // isFormData
  );

  const data = await response.json();
  return data;
};

// جلب بيانات الشركة (Company Profile)
export const getCompanyProfile = async () => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;
  const url = `https://${subdomain}.restocash.app/api/company/profite?api_password=${apiPassword}`;

  try {
    const response = await fetchWithAuth(url, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error(
        `Error fetching company profile: ${response.statusText}`
      );
    }

    const data = await response.json();
    return data || {};
  } catch (error) {
    console.error("Failed to fetch company profile:", error);
    throw error;
  }
};

// حذف الـ Items المحددة مع Retry Logic
export const deleteAllItems = async (maxRetries = 3, initialDelay = 1000) => {
  const subdomain = getSubdomain();
  const apiPassword = API_PASSWORD;
  const url = `https://${subdomain}.restocash.app/api/all/delete/items?api_password=${apiPassword}`;

  let lastError;
  
  for (let attempt = 0; attempt < maxRetries; attempt++) {
    try {
      const response = await fetchWithAuth(url, {
        method: "GET",
      });

      if (!response.ok) {
        // إذا كان الخطأ 429 (Too Many Requests)، حاول مجدداً
        if (response.status === 429) {
          lastError = new Error(`Error deleting items: ${response.statusText}`);
          // حساب التأخير مع exponential backoff
          const delay = initialDelay * Math.pow(2, attempt);
          console.warn(`⚠️ Too Many Requests (Attempt ${attempt + 1}/${maxRetries}). Retrying after ${delay}ms...`);
          await new Promise(resolve => setTimeout(resolve, delay));
          continue;
        }
        throw new Error(`Error deleting items: ${response.statusText}`);
      }

      const data = await response.json();
      return data || {};
    } catch (error) {
      lastError = error;
      
      // إذا كان آخر محاولة، رفع الخطأ
      if (attempt === maxRetries - 1) {
        console.error("Failed to delete items after retries:", error);
        throw error;
      }

      // تأخير قبل المحاولة التالية
      const delay = initialDelay * Math.pow(2, attempt);
      console.warn(`⚠️ Attempt ${attempt + 1} failed. Retrying after ${delay}ms...`);
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }

  // رفع آخر خطأ إذا فشلت جميع المحاولات
  throw lastError || new Error("Failed to delete items after maximum retries");
};
